import { render, staticRenderFns } from "./rewardPunishList.vue?vue&type=template&id=7cece4ca&scoped=true&"
import script from "./rewardPunishList.vue?vue&type=script&lang=js&"
export * from "./rewardPunishList.vue?vue&type=script&lang=js&"
import style0 from "./rewardPunishList.vue?vue&type=style&index=0&id=7cece4ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cece4ca",
  null
  
)

export default component.exports